import CustomButton from "container/components/CustomButton/CustomButton";
import assets from "assets";
import React from "react";
import styled from "styled-components";
import DialogLayout from "container/Dialogs/DialogLayout";
import { useDispatch } from "react-redux";

const StopModal = ({ onContinue, onClose, isStopModalOpen,fetchRewardPrompts }) => {
  const dispatch = useDispatch();
  const handleUpgrade = () => {
     fetchRewardPrompts()
    dispatch.utils.setSubscriptionModal(true);
    onClose(); // Close StopModal if upgrading
  };

  return (
    <DialogLayout open={isStopModalOpen}>
      <StyledModal>
        <p className="font-size-24 text-white medium">Don't want to see ads?</p>
        <p className="font-size-12 subtitle">
          Free accounts see ads every five prompts. Enjoy an ad-free experience
          by upgrading now.
        </p>
        <CustomButton
          label="Upgrade for $7/ mo"
          leftIcon={assets.arrow_up}
          onClick={handleUpgrade}
        />
        <p className="font-size-12 text-white link normal" onClick={onContinue}>
          No thanks, I want my 5 free prompts{" "}
        </p>
      </StyledModal>
    </DialogLayout>
  );
};

export default StopModal;

const StyledModal = styled.div`
  padding: 20px 50px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  background-color: #35363a;

  .font-size-24 {
    font-size: 24px;
  }

  .font-size-12 {
    font-size: 12px;
  }

  .subtitle {
    color: #afb7c0;
    max-width: 34ch;
    text-align: center;
    margin-block: 6px 20px;
  }

  .link {
    text-decoration: underline;
    margin-top: 20px;
    cursor: pointer;
  }
`;
